import PatientNameInputView from './PatientNameInputView';
import { PatientNameProvider } from '@context/PatientName';
const PatientNameInput = () => {
  return (
    <PatientNameProvider>
      <PatientNameInputView />
    </PatientNameProvider>
  );
};

export default PatientNameInput;
